import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { X } from 'lucide-react';

import './master-product-modal.scss';

const MasterProductModal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md',
  closeOnBackdrop = false,
  closeOnEscape = true,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (closeOnEscape && event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, closeOnEscape, onClose]);

  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (event) => {
    if (
      closeOnBackdrop &&
      event.target === event.currentTarget
    ) {
      onClose();
    }
  };

  return (
    <div
      className="master-product-modal-backdrop"
      role="presentation"
      onMouseDown={handleBackdropClick}
    >
      <div
        className={`master-product-modal master-product-modal-${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="master-product-modal-title"
        onMouseDown={(event) => event.stopPropagation()}
      >
        {/* =========================================
            HEADER
        ========================================== */}
        <div className="master-product-modal-header">
          <h2
            id="master-product-modal-title"
            className="master-product-modal-title"
          >
            {title}
          </h2>

          <button
            type="button"
            className="master-product-modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            <X
              size={24}
              strokeWidth={2}
              aria-hidden="true"
            />
          </button>
        </div>

        {/* =========================================
            BODY
        ========================================== */}
        <div className="master-product-modal-body">
          {children}
        </div>

        {/* =========================================
            FOOTER
        ========================================== */}
        {footer && (
          <div className="master-product-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
};

MasterProductModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  footer: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  closeOnBackdrop: PropTypes.bool,
  closeOnEscape: PropTypes.bool,
};

MasterProductModal.defaultProps = {
  children: null,
  footer: null,
  size: 'md',
  closeOnBackdrop: false,
  closeOnEscape: true,
};

export default MasterProductModal;